const cardItems = [
  {
    title: '新番速递：《仙王的日常生活》',
    desc: '仙王重生现代都市，用无敌实力过上低调校园生活，笑料不断。',
    img: 'https://readdy.ai/api/search-image?query=School%20life%20comedy%20manga%20scene%20with%20a%20powerful%20student%20in%20modern%20classroom%2C%20slice%20of%20life%20style%2C%20warm%20peach%20and%20cream%20color%20palette%2C%20lighthearted%20atmosphere%2C%20clean%20simple%20background&width=600&height=400&seq=cards-xianwang&orientation=landscape',
    tag: '搞笑',
    icon: 'ri-sparkling-line',
  },
  {
    title: '经典回顾：《全职高手》',
    desc: '荣耀之巅叶修归来，从零开始重返巅峰的电竞传奇。',
    img: 'https://readdy.ai/api/search-image?query=Esports%20themed%20manga%20scene%20with%20a%20skilled%20gamer%20in%20modern%20gaming%20setup%2C%20neon%20accent%20lights%20in%20warm%20tones%2C%20stylish%20character%20design%2C%20clean%20composition&width=600&height=400&seq=cards-quanzhi&orientation=landscape',
    tag: '竞技',
    icon: 'ri-gamepad-line',
  },
  {
    title: '恋爱甜饼：《怦然心动》',
    desc: '青梅竹马的纯真恋爱故事，温暖治愈每一颗年少的心。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20school%20life%20manga%20scene%20with%20two%20young%20characters%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20peach%20tones%2C%20gentle%20lighting%2C%20sweet%20atmosphere%2C%20clean%20simple%20background&width=600&height=400&seq=cards-pengran&orientation=landscape',
    tag: '恋爱',
    icon: 'ri-heart-line',
  },
  {
    title: '悬疑神作：《端脑》',
    desc: '烧脑推理与生死游戏交织，每一页都让你屏住呼吸。',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20manga%20scene%20with%20puzzle%20elements%20and%20dramatic%20lighting%2C%20dark%20warm%20amber%20tones%2C%20suspenseful%20atmosphere%2C%20clean%20minimal%20composition%2C%20psychological%20theme&width=600&height=400&seq=cards-duannao&orientation=landscape',
    tag: '悬疑',
    icon: 'ri-lightbulb-flash-line',
  },
  {
    title: '国漫之光：《镇魂街》',
    desc: '人灵共存的世界，守护灵与寄灵人的热血羁绊故事。',
    img: 'https://readdy.ai/api/search-image?query=Supernatural%20action%20manga%20scene%20with%20ancient%20warrior%20spirits%20in%20modern%20urban%20setting%2C%20dramatic%20warm%20golden%20and%20coral%20lighting%2C%20epic%20atmosphere%2C%20Chinese%20manga%20style&width=600&height=400&seq=cards-zhenhun&orientation=landscape',
    tag: '热血',
    icon: 'ri-sword-line',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精选推荐</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">编辑精选优质漫画，发现更多值得一读的好作品</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-2xl overflow-hidden group hover:scale-[1.02] transition-transform duration-300 cursor-pointer">
              <div className="aspect-[3/2] overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <div className="w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className={`${item.icon} text-primary-500 text-xs`}></i>
                  </div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap">{item.tag}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
          {cardItems.length < 5 && (
            <div className="bg-background-50 rounded-2xl overflow-hidden group hover:scale-[1.02] transition-transform duration-300 cursor-pointer">
              <div className="aspect-[3/2] overflow-hidden">
                <img src={cardItems[0].img} alt="更多推荐" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <div className="w-6 h-6 rounded-full bg-secondary-100 flex items-center justify-center">
                    <i className="ri-more-line text-secondary-500 text-xs"></i>
                  </div>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">更多</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">探索更多漫画</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">前往漫画分类发现更多优质作品，精彩内容等你来发掘。</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}